import { render, staticRenderFns } from "./VirtualCard.vue?vue&type=template&id=36e26026&scoped=true&"
import script from "./VirtualCard.vue?vue&type=script&lang=js&"
export * from "./VirtualCard.vue?vue&type=script&lang=js&"
import style0 from "./VirtualCard.vue?vue&type=style&index=0&id=36e26026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e26026",
  null
  
)

export default component.exports